export const IMPORTANT_NOTE_MARKER = '[[DC_IMPORTANT_NOTE_V1]] '

/**
 * Prepends the important note marker to the given text.
 * @param text The original note text
 * @returns The note text with the important marker prepended
 */
export function markImportantJourneyNote(text: string): string {
    if (!text) return text
    if (text.startsWith(IMPORTANT_NOTE_MARKER)) return text
    return `${IMPORTANT_NOTE_MARKER}${text}`
}

/**
 * Parses a note text to check if it's marked as important, and returns the cleaned text.
 * @param text The note text to parse
 * @returns An object containing the clean text and a boolean indicating if it's important
 */
export function parseImportantJourneyNote(text: string): {
    text: string
    isImportant: boolean
} {
    if (!text) return { text: '', isImportant: false }

    if (text.startsWith(IMPORTANT_NOTE_MARKER)) {
        return {
            text: text.substring(IMPORTANT_NOTE_MARKER.length),
            isImportant: true,
        }
    }

    return { text, isImportant: false }
}
